<div class="main-page container">
  <fc-bread-crumb-navigation [navigationString]="'Manage Info / Buyer / Edit Buyer'"></fc-bread-crumb-navigation>
  <ng-container>
    <h1>Edit Buyer</h1>
  </ng-container>
  <div class="main-panel">
    <div class="error-message">{{ error }}</div>
    <ng-container *ngIf="buyerForm">
      <form [formGroup]="buyerForm">
        <input formControlName="id" type="hidden" />
        <div class="form-container">
          <div class="fields">
            <mat-form-field class="w-100-1">
              <mat-label>Name</mat-label>
              <input formControlName="name" id="name" matInput matInput type="text" />
            </mat-form-field>
            <mat-form-field class="w-100-1">
              <mat-label>Short Name</mat-label>
              <mat-hint><strong>Cannot be edited in UI</strong></mat-hint>
              <input formControlName="short_name" id="short_name" matInput readonly type="text" />
            </mat-form-field>
            <mat-form-field class="w-100-1">
              <mat-label ßfor="referrer_code">Referrer Code</mat-label>
              <input formControlName="referrer_code" id="referrer_code" matInput type="text" />
            </mat-form-field>
            <mat-form-field class="w-100-1">
              <mat-label>Google Analytics gtag ID</mat-label>
              <input formControlName="gtag_id" id="gtag_id" matInput type="text" />
            </mat-form-field>
            <mat-form-field class="w-100-1">
              <mat-label>slogan</mat-label>
              <input formControlName="slogan" id="slogan" matInput type="text" />
            </mat-form-field>
            <mat-form-field class="w-100-1">
              <mat-label>url</mat-label>
              <input formControlName="url" id="url" matInput type="text" />
            </mat-form-field>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <h2>Contract Substitution Values</h2>
              </mat-expansion-panel-header>
              <mat-form-field class="w-100-1">
                <mat-label>contact_address_line_1</mat-label>
                <input formControlName="contact_address_line_1" id="contact_address_line_1" matInput type="text" />
              </mat-form-field>
              <mat-form-field class="w-100-1">
                <mat-label>contact_address_line_2</mat-label>
                <input formControlName="contact_address_line_2" id="contact_address_line_2" matInput type="text" />
              </mat-form-field>
              <mat-form-field class="w-100-1">
                <mat-label>contact_city</mat-label>
                <input formControlName="contact_city" id="contact_city" matInput type="text" />
              </mat-form-field>
              <mat-form-field class="w-100-1">
                <mat-label>contact_state</mat-label>
                <input formControlName="contact_state" id="contact_state" matInput type="text" />
              </mat-form-field>
              <mat-form-field class="w-100-1">
                <mat-label>contact_zip</mat-label>
                <input formControlName="contact_zip" id="contact_zip" matInput type="text" />
              </mat-form-field>
            </mat-expansion-panel>

            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <h2>Stripe Settings</h2>
              </mat-expansion-panel-header>
              <mat-form-field class="w-100-1">
                <mat-label>stripe_secret_key</mat-label>
                <input formControlName="stripe_secret_key" id="stripe_secret_key" matInput type="text" />
              </mat-form-field>
              <mat-form-field class="w-100-1">
                <mat-label>stripe_public_key</mat-label>
                <input formControlName="stripe_public_key" id="stripe_public_key" matInput type="text" />
              </mat-form-field>
              <mat-form-field class="w-100-1">
                <mat-label>stripe_client_id</mat-label>
                <input formControlName="stripe_client_id" id="stripe_client_id" matInput type="text" />
              </mat-form-field>
            </mat-expansion-panel>

            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <h2>Docusign Values</h2>
              </mat-expansion-panel-header>
              <mat-form-field class="w-100-1">
                <mat-label>secondary_signer_name</mat-label>
                <input formControlName="secondary_signer_name" id="secondary_signer_name" matInput type="text" />
              </mat-form-field>
              <mat-form-field class="w-100-1">
                <mat-label>secondary_signer_title</mat-label>
                <input formControlName="secondary_signer_title" id="secondary_signer_title" matInput type="text" />
              </mat-form-field>
              <mat-form-field class="w-100-1">
                <mat-label>secondary_signer_email</mat-label>
                <input formControlName="secondary_signer_email" id="secondary_signer_email" matInput type="text" />
              </mat-form-field>
              <mat-form-field class="w-100-1">
                <mat-label>docusign_integrator_key</mat-label>
                <input formControlName="docusign_integrator_key" id="docusign_integrator_key" matInput type="text" />
              </mat-form-field>
              <mat-form-field class="w-100-1">
                <mat-label>docusign_user_id</mat-label>
                <input formControlName="docusign_user_id" id="docusign_user_id" matInput type="text" />
              </mat-form-field>
              <mat-form-field class="w-100-1">
                <mat-label>docusign_private_key</mat-label>
                <input formControlName="docusign_private_key" id="docusign_private_key" matInput type="text" />
              </mat-form-field>
              <mat-form-field class="w-100-1">
                <mat-label>buyer_signature_settings</mat-label>
                <input formControlName="buyer_signature_settings" id="buyer_signature_settings" matInput type="text" />
              </mat-form-field>
              <mat-form-field class="w-100-1">
                <mat-label>landowner_signature_settings</mat-label>
                <input
                  formControlName="landowner_signature_settings"
                  id="landowner_signature_settings"
                  matInput
                  type="text" />
              </mat-form-field>
              <mat-form-field class="w-100-1">
                <mat-label>landowner_title_settings</mat-label>
                <input formControlName="landowner_title_settings" id="landowner_title_settings" matInput type="text" />
              </mat-form-field>
              <mat-form-field class="w-100-1">
                <mat-label>landowner_entity_settings</mat-label>
                <input
                  formControlName="landowner_entity_settings"
                  id="landowner_entity_settings"
                  matInput
                  type="text" />
              </mat-form-field>
            </mat-expansion-panel>

            <mat-divider [ngStyle]="{ 'margin-top': '20px' }"></mat-divider>
            <button
              (click)="onSubmit()"
              [disabled]="!isSuperAdmin"
              class="submit-button"
              color="primary"
              data-cy="button-submit"
              mat-raised-button>
              Update Buyer
            </button>
          </div>
        </div>
      </form>
      <div class="welcome-documents">
        <h4>Welcome Documents</h4>
        <div *ngFor="let doc of welcomeDocs">
          <fa-icon
            (click)="removeWelcomeDoc($event, doc)"
            *ngIf="isSuperAdmin"
            [icon]="['far', 'trash']"
            class="red"></fa-icon>
          <a [href]="doc.url" class="doc-link" target="_blank">
            {{ doc.name }}
          </a>
        </div>
        <mat-divider [ngStyle]="{ 'margin-top': '45px' }"></mat-divider>
        <button
          (click)="uploadWelcomeDoc($event)"
          [disabled]="!isSuperAdmin"
          class="submit-button"
          color="primary"
          mat-raised-button>
          Upload a Document
        </button>
      </div>
    </ng-container>
  </div>
</div>
<input
  #welcomeDocFileUpload
  accept=".pdf,.doc,.docx,.odt,.ppt,.pptx,.png,.jpg,.gif"
  hidden
  id="yieldCurveFileUpload"
  name="yieldCurveFileUpload"
  type="file" />
